export class GetProfileMedia {
    public static readonly type = '[ProfileMedia] get all profile medias';
}

export class DeleteProfileMedia {
    public static readonly type = '[ProfileMedia] Delete profile media';
    constructor(public mediaId: string) {}
}
